import { StarRating } from '@/components/StarRating';
import type React from 'react';
import { useState } from 'react';
import styles from './index.module.scss';

export type RolePlayFeedbackProps = {
  onCreateRolePlayFeedback: (rating: number, comment: string) => Promise<void>;
  isFeedbackCreating: boolean;
  isFeedbackCreated: boolean;
};

export const RolePlayFeedback: React.FC<RolePlayFeedbackProps> = ({
  onCreateRolePlayFeedback,
  isFeedbackCreating,
  isFeedbackCreated,
}) => {
  const [rating, setRating] = useState<number | null>(null);
  const [comment, setComment] = useState('');

  const isFormValid = rating !== null;

  if (isFeedbackCreated) {
    return (
      <div className={styles.successContainer}>
        <p className={styles.successTitle}>回答を送信しました</p>
        <p className={styles.successSubtitle}>
          アンケートへのご協力ありがとうございました
        </p>
      </div>
    );
  }

  return (
    <div className={styles.feedbackContainer}>
      <div className={styles.contentWrapper}>
        <h2 className={styles.title}>あなたの感想をお聞かせください（任意）</h2>

        <div className={styles.section}>
          <div className={styles.questionContainer}>
            <label htmlFor="star-rating" className={styles.questionText}>
              ロールプレイの評価内容はどうでしたか？（5段階評価）
            </label>
            <div id="star-rating">
              <StarRating
                rating={rating}
                onRatingChange={setRating}
                disabled={isFeedbackCreating}
              />
            </div>
          </div>

          <div className={styles.questionContainer}>
            <div className={styles.commentHeader}>
              <label htmlFor="feedback-comment" className={styles.questionText}>
                ロールプレイの評価について、感想やご意見を自由に記入ください
              </label>
              <p className={styles.description}>
                具体的な内容をご記入いただくと、より良いサービス向上につながります。
              </p>
            </div>
            <div className={styles.textareaContainer}>
              <textarea
                id="feedback-comment"
                className={styles.textarea}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                disabled={isFeedbackCreating}
                placeholder=""
                maxLength={1000}
              />
              <p className={styles.charCount}>（1000文字以内）</p>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <button
          type="button"
          onClick={() => {
            if (rating !== null) {
              onCreateRolePlayFeedback(rating, comment);
            }
          }}
          disabled={!isFormValid || isFeedbackCreating}
          className={
            !isFormValid || isFeedbackCreating
              ? styles.submitButtonInactive
              : styles.submitButtonActive
          }
        >
          {isFeedbackCreating ? '送信中...' : '回答を送信する'}
        </button>
      </div>
    </div>
  );
};
